var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Followers",
    clipPath: "url(#clip0_8456_13220)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.87207 9.625C9.80507 9.625 11.3721 8.058 11.3721 6.125C11.3721 4.192 9.80507 2.625 7.87207 2.625C5.93907 2.625 4.37207 4.192 4.37207 6.125C4.37207 8.058 5.93907 9.625 7.87207 9.625Z",
    stroke: "#878E95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.62842 18.375V16.625C2.62842 15.6967 2.99717 14.8065 3.65354 14.1501C4.30992 13.4937 5.20016 13.125 6.12842 13.125H9.62842C10.5567 13.125 11.4469 13.4937 12.1033 14.1501C12.7597 14.8065 13.1284 15.6967 13.1284 16.625V18.375",
    stroke: "#878E95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.0015 2.73828C14.7543 2.93104 15.4216 3.36889 15.8981 3.9828C16.3747 4.59671 16.6333 5.35176 16.6333 6.12891C16.6333 6.90606 16.3747 7.6611 15.8981 8.27501C15.4216 8.88892 14.7543 9.32677 14.0015 9.51953",
    stroke: "#878E95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.3784 18.3746V16.6246C18.374 15.8521 18.1141 15.1028 17.6393 14.4935C17.1645 13.8841 16.5014 13.449 15.7534 13.2559",
    stroke: "#878E95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8456_13220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowers);
export default __webpack_public_path__ + "static/media/followers.30677512.svg";
export { ForwardRef as ReactComponent };